import {
  CompositeFilterDescriptor,
  SortDescriptor,
  State,
} from '@progress/kendo-data-query'

export class PendingTransactionViewState {
  selectedView: string
  filter: CompositeFilterDescriptor
  sort: SortDescriptor[]
  filterByBranch: string

  constructor(data: any = {}) {
    this.selectedView = data.selectedView || 'all'
    this.filter = data.filter || { logic: 'and', filters: [] }
    this.sort = data.sort || [
      {
        field: 'dateReceived',
        dir: 'desc',
      },
    ]
    this.filterByBranch = data.filterByBranch || 'Filter By Branch'
  }
}

export class TransactionViewState {
  filter: CompositeFilterDescriptor
  sort: SortDescriptor[]
  transactionId: number | null
  clientId?: number
  clientName: string
  accountName: string
  accountNumber?: string
  selectedBranch: string
  selectedRepId: number
  selectedRepCode: string | null
  selectedStatus: number | null
  approvalStartDate: Date | null
  approvalEndDate: Date | null
  dateReceivedStartDate: Date | null
  dateReceivedEndDate: Date | null
  pageSize?: number

  constructor(data: any = {}) {
    this.filter = data.filter || { logic: 'and', filters: [] }
    this.sort = data.sort || [
      {
        field: 'dateSubmitted',
        dir: 'desc',
      },
    ]
    this.transactionId = data.transactionId
    this.clientId = data.clientId || ''
    this.clientName = data.clientName || ''
    this.accountName = data.accountName || ''
    this.selectedBranch = data.selectedBranch || ''
    this.selectedRepId = data.selectedRep || 0
    this.selectedStatus = data.selectedStatus || null
    this.approvalStartDate = data.approvalStartDate
    this.approvalEndDate = data.approvalEndDate
    this.dateReceivedStartDate = data.dateReceivedStartDate
    this.dateReceivedEndDate = data.dateReceivedEndDate
    this.pageSize = data.pageSize || 50
  }
}

export class TransactionWithPendingAlertsViewState {
  gridState: State
  selectedBranch: string
  selectedRep: number
  selectedStatus: number | null
  submittedStartDate: Date | null
  submittedEndDate: Date | null

  constructor(data: any = {}) {
    this.gridState = data.gridState || {
      skip: 0,
      take: 10,
      sort: [
        {
          field: 'dateReceived',
          dir: 'desc',
        },
      ],
      filter: {
        logic: 'and',
        filters: [],
      },
    }
    this.selectedBranch = data.selectedBranch || ''
    this.selectedRep = data.selectedRep || 0
    this.selectedStatus = data.selectedStatus || null
    this.submittedStartDate = data.dateReceivedStartDate
    this.submittedEndDate = data.dateReceivedEndDate
  }
}

export class AccountViewState {
  filter: CompositeFilterDescriptor
  sort: SortDescriptor[]

  constructor(data: any = {}) {
    this.filter = data.filter || { logic: 'and', filters: [] }
    this.sort = data.sort || [
      {
        field: 'modifiedDate',
        dir: 'desc',
      },
    ]
  }
}
